import { render, staticRenderFns } from "./HorizontalTabs.vue?vue&type=template&id=3fe79c4c&"
import script from "./HorizontalTabs.vue?vue&type=script&lang=js&"
export * from "./HorizontalTabs.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports